import { IconNames } from '@dixa/lib-shared-habla';
import { config } from 'lib-shared-backend-config';

export const CARD_V2 = '2';

export type KnownCardTypes = 'custom' | 'magento' | 'shopify' | 'salesforce';

type CardStyle = { icon: IconNames; className?: string; iconUrl?: string };

const cardStyles: Record<KnownCardTypes, CardStyle> = {
  custom: {
    icon: 'code' as const,
    className: '',
  },
  magento: {
    icon: 'magento' as const,
    className: 'magento',
  },
  shopify: {
    icon: 'shopify' as const,
    className: 'shopify',
  },
  salesforce: {
    icon: 'salesforce' as const,
    className: 'salesforce',
  },
};

const defaultCardStyle: CardStyle = {
  icon: 'code' as const,
  className: '',
};

const STYLESHEET_HREF = `${config.url.toolkit}/cards/v1/style.css`;

// Initialise lazily
let defaultStylesheet: string | null = null;
export const getStylesheet = (): string => {
  if (defaultStylesheet) return defaultStylesheet;

  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = STYLESHEET_HREF;

  defaultStylesheet = link.outerHTML;

  return defaultStylesheet;
};

export const getCardStyle = (
  type: KnownCardTypes,
  iconUrl?: string,
): CardStyle => {
  const baseStyle = cardStyles[type] || defaultCardStyle;

  return iconUrl ? { ...baseStyle, iconUrl } : baseStyle;
};
